@if (client === 'masofa'  ) {
  <msfa-summary-wrapper
    [title]="title"
    [items]="items"
    [leftSize]="leftSize"
    [rightSize]="rightSize"
    [separator]="separator"
  >
    <div right #right [style.height]="'100%'">
      <ng-container *ngTemplateOutlet="templateRight"></ng-container>
    </div>
  </msfa-summary-wrapper>
} @else if (client === 'agrosense' || client === 'demo') {
  <agr-summary-wrapper
    [title]="title"
    [items]="items"
    [leftSize]="leftSize"
    [rightSize]="rightSize"
    [separator]="separator"
  >
    <div right #right [style.height]="'100%'">
      <ng-container *ngTemplateOutlet="templateRight"></ng-container>
    </div>
  </agr-summary-wrapper>
}

<ng-template #templateRight>
  <ng-content select="[right]"></ng-content>
</ng-template>

<ng-template #templateLeft>
  <ng-content select="[left]"></ng-content>
</ng-template>

